<nz-form-item>
  <nz-form-label [nzRequired]="to.required">{{ to.label }}</nz-form-label>
  <nz-form-control [nzErrorTip]="errorTpl" [nzValidateStatus]="errorState">
    <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixEyes">
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        nz-input
        [formControl]="formControl"
        [placeholder]="to.placeholder"
        autocomplete="new-password"
      />
    </nz-input-group>
    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field"></formly-validation-message>
    </ng-template>
  </nz-form-control>
</nz-form-item>
<ng-template #prefixLock>
  <span nz-icon nzType="lock" nzTheme="outline"></span>
</ng-template>
<ng-template #suffixEyes>
  <span
    nz-icon
    [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
    nzTheme="outline"
    (click)="passwordVisible = !passwordVisible"
  ></span>
</ng-template>
